import { boxShadowValuesV2 } from '@shared/utils/style/dropShadows';
import type { StyleSystemProps } from '@withjoy/joykit';

const root: StyleSystemProps = {
  height: '100%',
  width: '100%',
  borderRadius: '12px',
  display: 'block',
  objectFit: 'cover',
  boxShadow: boxShadowValuesV2.xxxl,
};

export const styles = {
  root,
};
